import React, {useState, useEffect} from 'react';
import './App.css';
import Home from './home/Home';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import UserList from './user/UserList';
import EditUser from './user/EditUser';
import {CookiesProvider, useCookies} from 'react-cookie';
import FooterBar from './Footer';
import Onboarding from './onboarding/Onboarding';
import OnboardingPersonal from './onboarding/OnboardingPersonal';
import OnboardingOthers1 from './onboarding/OnboardingOthers1';
import OnboardingOthers2 from './onboarding/OnboardingOthers2';
import OnboardingOthers3 from './onboarding/OnboardingOthers3';
import OnboardingProfile from "./onboarding/OnboardingProfile";
import OnboardingLoansSpinwheel  from "./onboarding/OnboardingLoansSpinwheel";
import PrivacyPolicy from "./legal/PrivacyPolicy";
import TermsOfUse from "./legal/TermsOfUse";
import OnboardingOthersFullNine from './onboarding/OnboardingOthersFullNine';
import MainContent from './components/MainContent/MainContent';
import Refinance from './refinance/refinance';
import Payment from './payment/payment';
import Profile from './profile/profile';
import Loans from './loans/loans';
import Menu from './components/Menu/Menu';
import './styles/index.scss';
import IdleTimer from "./IdleTimer";
import Spinwheel from './spinwheel/spinwheel';
import Optin from "./legal/Optin";
import Glbf from "./legal/Glbf";
import EmailVerification from "./verify/EmailVerification";


export default function App() {
    const [isTimeout,setIsTimeout] = useState(false);
    const [cookie, setCookie] = useCookies();
    
    //const csrfToken = useCookies('XSRF-TOKEN');
    console.log('appjs', cookie['XSRF-TOKEN']);

    useEffect(() => {
        const timer = new IdleTimer({
            timeOutInSeconds: process.env.NODE_ENV === 'production' ? 300 : 2000,
            onTimeout() {
                setIsTimeout(true);
            },
            onExpired() {
                setIsTimeout(true);
            },
            logout() {
                this.logout();
            }
        });
        return () => {
            console.log("return");
            timer.cleanUp();
        }
    }, [isTimeout]);

     const logout = () => {
         console.log(process.env.NODE_ENV);
         console.log("logout from App class");
         console.log(cookie['XSRF-TOKEN'].toString())
         fetch('/alumsum/logout', {
             method: 'POST', credentials: 'include',
             headers: {'X-XSRF-TOKEN': cookie['XSRF-TOKEN']}
         }).then(res => res.json())
             .then(response => {
                 console.log(response);
                 window.location.href = response.logoutUrl + "?id_token_hint=" +
                     response.idToken + "&post_logout_redirect_uri=" + window.location.origin;
             });
     }

    if(isTimeout) {
        console.log("logging out due to inactivity");
        logout();
    } else {
    return (
        <CookiesProvider>
            <Router>
                <div>
                    <Switch>
                        <Route path='/' exact={true} component={Home}/>
                        <Route path='/alumsum/users' exact={true} component={UserList}/>
                        <Route path='/alumsum/user/:id' exact={true} component={EditUser}/>
                        <Route path='/alumsum/onboarding' exact={true} component={Onboarding}/>
                        <Route path='/alumsum/onboardingpersonal' exact={true} component={OnboardingPersonal}/>
                        <Route path='/alumsum/onboardingothers1' exact={true} component={OnboardingOthers1}/>
                        <Route path='/alumsum/onboardingothers2' exact={true} component={OnboardingOthers2}/>
                        <Route path='/alumsum/onboardingothers3' exact={true} component={OnboardingOthers3}/>
                        <Route path='/alumsum/onboardingothers' exact={true} component={OnboardingOthersFullNine}/>
                        <Route path='/alumsum/onboardingprofile' exact={true} component={OnboardingProfile}/>
                        <Route path='/alumsum/onboardingloans' exact={true} component={Loans}/>
                        <Route path='/alumsum/onboardingloansspinwheel' exact={true} component={OnboardingLoansSpinwheel}/>
                        <Route path='/alumsum/privacypolicy' exact={true} component={PrivacyPolicy}/>
                        <Route path='/alumsum/termsofuse' exact={true} component={TermsOfUse}/>
                        <Route path='/alumsum/dashboard' exact={true} component={MainContent}/>
                        <Route path='/alumsum/dashboard/refinance' exact={true} component={Refinance}/>
                        <Route path='/alumsum/dashboard/payment' exact={true} component={Payment}/>
                        <Route path='/alumsum/dashboard/profile' exact={true} component={Profile}/>
                        <Route path='/alumsum/dashboard/loans' exact={true} component={Loans}/>
                        <Route path='/alumsum/spinwheel' exact={true} component={Spinwheel}/>
                        <Route path='/alumsum/optin' exact={true} component={Optin}/>
                        <Route path='/alumsum/glbf' exact={true} component={Glbf}/>
                        <Route path='/alumsum/email_verification' exact={true} component={EmailVerification}/>
                    </Switch>
                    {/*<FooterBar/>*/}
                </div>
            </Router>
        </CookiesProvider>
    )}
}
